module.exports = __webpack_public_path__ + "static/steve-smith-ardalis-200x200-08d9c30480b3e2c6c94fe060d1b098f3.jpg";